export default "__VITE_ASSET__CRioSwRn__"